import React from 'react';
import ScreenComponent from './ScreenComponent';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert, topbarUpdate } from '../../actions';
import '../../styles/elements/screen.scss';
import '../../styles/screens/integrations.scss';
import TranslationService from "../../app/services/TranslationService";
import axios from "axios";
import {config} from "../../app/config";
import {Button} from "../icymat-design/Button";
import {Input} from "../icymat-design/Input";
import {Textarea} from "../icymat-design/Textarea";


class PressCenterClass extends ScreenComponent
{
    constructor(props) {
        super(props);

        this.state = {
            smsNumber: '',
            smsMessage: ''
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== this.getScreenName() && this.props.view === this.getScreenName()) {
            this.props.topbarUpdate({
                action1: null,
                action2: null,
                actionBig: null
            });
        }
    };

    getScreenName() {
        return 'press-center';
    };

    loginIntoPressCenter = () => {
        this.props.preloaderShow();
        let that = this;

        axios.get(config.apiAddress + '/module/press-center/token')
            .then(function (response) {
                window.open(that.getAddress() + '/w/login?token=' + response.data.token, '_blank').focus();
                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'menu.press_center.actions.token_failed'));
                that.props.preloaderHide();
            });
    };

    sendSMS = () => {
        this.props.preloaderShow();
        let that = this;

        axios.post(
            config.apiAddress + '/sms',
            {
                number: this.state.smsNumber,
                content: this.state.smsMessage
            }
        ).then(function (response) {
            that.props.alert('Wiadomość została wysłana');
            that.setState({smsNumber: '', smsMessage: ''});
            that.props.preloaderHide();
        }).catch(function(error) {
            that.props.alert('Nie udało się wysłać wiadomości');
            that.props.preloaderHide();
        });
    }

    getAddress() {
        if (this.props.user === null || this.props.user.domain === null) {
            return 'undefined';
        }

        let address = this.props.user.domain;

        if (address === null) {
            return 'undefined';
        }

        if (address.indexOf('.') < 0) {
            return document.location.protocol + '//' + address + '.' + document.location.hostname;
        }

        return document.location.protocol + '//' + address;
    }

    render() {
        /* eslint-disable */
        return (
            <div className="screen imd-text-accent" style={this.getStyle()} id="screen-integrations">
                <h1>{TranslationService.trans(this.props.language, 'menu.press_center')}</h1>

                <div>
                    <strong>{TranslationService.trans(this.props.language, 'press_center.address')}: </strong>
                    <a href={this.getAddress()} target="_blank">{this.getAddress()}</a>
                </div>

                <div>
                    <Button
                        color={'main'}
                        text={TranslationService.trans(this.props.language, 'press_center.sign_in')}
                        onClick={() => this.loginIntoPressCenter()}
                    />
                </div>

                <hr />

                <div style={{maxWidth: '600px'}}>
                    <h2>SMS</h2>

                    <Input
                        color={'main'}
                        placeholder={TranslationService.trans(this.props.lang, 'common.number')}
                        value={this.state.smsNumber}
                        onChange={(e) => this.setState({smsNumber: e.target.value})}
                    />
                    <Textarea
                        color={'main'}
                        placeholder={TranslationService.trans(this.props.lang, 'common.content')}
                        value={this.state.smsMessage}
                        onChange={(e) => this.setState({smsMessage: e.target.value})}
                    />

                    <Button
                        color={'main'}
                        text={TranslationService.trans(this.props.lang, 'common.send')}
                        onClick={() => this.sendSMS()}
                    />
                </div>
            </div>
        );
        /* eslint-enable */
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        device: state.login.device,
        view: state.view,
        user: state.user,
        language: TranslationService.getLanguage(state.user)
    }
};

export const PressCenterScreen = connect(mapStateToProps, {preloaderShow, preloaderHide, alert, topbarUpdate})(PressCenterClass);
